// routes-initializer.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { RoutesService } from '../services/routes.service';

@Injectable({
  providedIn: 'root'
})
export class RoutesInitializerGuard implements CanActivate, CanActivateChild {
  private routesLoaded = false;
  private loadingRoutes = false;

  constructor(
    private routesService: RoutesService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> | boolean {
    return this.ensureRoutesLoaded();
  }

  canActivateChild(): Observable<boolean> | boolean {
    return this.ensureRoutesLoaded();
  }

  private ensureRoutesLoaded(): Observable<boolean> | boolean {
    // Si las rutas ya están cargadas, permitir navegación inmediatamente
    if (this.routesLoaded) {
      return true;
    }

    // Si ya se están cargando, esperar
    if (this.loadingRoutes) {
      return of(false);
    }

    // Marcar que estamos cargando
    this.loadingRoutes = true;
    console.log('Cargando rutas dinámicas...');

    return this.routesService.getAngularRoutes().pipe(
      tap(routes => {
        console.log('Rutas cargadas exitosamente');
        this.router.resetConfig(routes);
        this.routesLoaded = true;
        this.loadingRoutes = false;
      }),
      map(() => true),
      catchError(error => {
        console.error('Error al cargar rutas:', error);
        this.loadingRoutes = false;
        // Cargar rutas de fallback
        this.router.resetConfig([
          { path: '', redirectTo: 'login', pathMatch: 'full' },
          { path: 'login', component: this.routesService.getLoginComponent() },
          { path: 'home', component: this.routesService.getPagesComponent() },
          { path: '**', redirectTo: 'login' }
        ]);
        return of(true);
      })
    );
  }

  // Método para resetear el estado (útil para testing o logout)
  resetRoutesState(): void {
    this.routesLoaded = false;
    this.loadingRoutes = false;
  }
}